<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on, attrs }">
            <a href="javascript:void(0)"  
                @click="addCategoryModal = true" 
                 v-bind="attrs"
                v-on="on"
                class="mt-1"> {{ $page.props.lang.addCategory || "Create New Category" }} </a>
      </template>
        <v-card>
            <v-toolbar elevation="0">
                <v-toolbar-title>{{ $page.props.lang.newCategory || "New category" }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="8">    
                            <p class="custom-label">{{ $page.props.lang.category_name || 'Category name' }}</p>
                            <v-text-field v-model="newCategory.name" 
                                    :error-messages="responseErrors.name" :hide-details="!responseErrors.name"
                                    @focus="responseErrors.name=''" outlined dense></v-text-field>
                        </v-col> 
                        <v-col cols="4">
                            <v-btn @click="saveCategory" :loading="savingCategory" color="primary" class="mt-6 ml-8">{{ $page.props.lang.save || "Save" }}</v-btn>
                        </v-col>    
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import EventBus from '@/js/eventbus'

export default {
    data() {
        return{
            dialog: false,
            responseErrors: {},
            newCategory: {
                name: '',
                type: 'exercise'
            },
            savingCategory: false
        }
    },
    methods: {
        saveCategory() {
            this.savingCategory = true;
            axios.post('/backoffice/categories/store', this.newCategory)
                .then(response => {
                    this.savingCategory = false;
                    if (response.data.status==="OK") {
                        this.dialog = false;

                        EventBus.$emit('NEW_CATEGORY_ADDED', response.data.category);
                        // this.categoriesData.push({id: response.data.category.id, name: response.data.category.name});
                        // this.newExpense.category_id = response.data.category.id;
                        
                    }
                })
                .catch(error => {     
                    this.savingCategory = false;              
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
        }
    }
}
</script>
